@if (visible) {
  <div
    class="relative z-[25] bg-white -mt-[170px] p-4 mb-4 pt-[100px] flex justify-center gap-4 border-b border-gray-300">
    <div class="flex flex-wrap justify-center gap-3">
      <p-button
        (click)="downloadSelected.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? downloadSelected.emit(): null"
        icon="pi pi-download"
        severity="info"
        [label]="'animalDocuments.selection.download' | transloco"
      />
      <p-button
        (click)="deleteSelected.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? deleteSelected.emit(): null"
        icon="pi pi-trash"
        severity="danger"
        [label]="'animalDocuments.selection.delete' | transloco"
      />
      <p-button
        (click)="cancelSelection.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? cancelSelection.emit(): null"
        icon="pi pi-times"
        styleClass="p-button-outlined border-gray-400 text-gray-600 hover:bg-gray-100 hover:border-gray-500"
        severity="secondary"
        [label]="'modal.cancel' | transloco"
      />
    </div>
  </div>
}

@if (visible) {
  <div class="fixed inset-0 bg-white/75 z-10 pointer-events-auto"></div>
}
